import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../data/reviews";
import { ChapterHeader, Reveal } from "./Reveal";

const Stars = ({ n }) => (
  <div className="flex gap-0.5">
    {[...Array(n)].map((_, i) => (
      <Star key={i} className="w-3.5 h-3.5 text-chili fill-chili" />
    ))}
  </div>
);

export const Reviews = () => (
  <section id="price" className="relative py-28 sm:py-40 overflow-hidden bg-white" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <ChapterHeader
        number="04"
        title={<>Priče <span className="text-leafdark">gostiju</span></>}
      />

      <Reveal>
        <div className="flex flex-wrap items-end gap-6 mb-16" data-testid="reviews-score-banner">
          <p className="font-display font-black text-7xl sm:text-8xl leading-none text-chili">4.5</p>
          <div className="pb-2">
            <Stars n={5} />
            <p className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-leafdark/80 mt-2">
              Google recenzije · stotine utisaka
            </p>
          </div>
        </div>
      </Reveal>

      <div className="columns-1 md:columns-2 lg:columns-3 gap-6" data-testid="reviews-container">
        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ delay: (i % 3) * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`review-card-${i}`}
            className="glow-card break-inside-avoid mb-6 rounded-[1.5rem] border border-leaf/15 bg-white p-7"
          >
            <Quote className="w-5 h-5 text-leaf mb-4" />
            <blockquote className="text-leafdark text-[15px] leading-relaxed">{r.text}</blockquote>
            <figcaption className="mt-6 pt-5 border-t border-leaf/15 flex items-center justify-between gap-3">
              <div>
                <p className="font-semibold text-sm text-ember">{r.name}</p>
                <p className="font-mono-x text-[10px] uppercase tracking-[0.15em] text-leafdark/60 mt-1">{r.meta}</p>
              </div>
              <Stars n={r.stars} />
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
